import { useState } from "react";
import { getMetaCsrf } from "../util/basicRenders";

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const signup = async (
    firstName,
    lastName,
    email,
    password,
    role,
    organization,
    department,
    country,
    loginLink,
    roleAudit
  ) => {
    setIsLoading(true);
    setError(null);

    const response = await fetch("/api/user/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": getMetaCsrf()
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        password,
        role,
        organization,
        department,
        country,
        loginLink,
        roleAudit
      })
    });
    //json is the object with email and token
    const json = await response.json();
    // console.debug("signup json: ", json);

    if (!response.ok) {
      setIsLoading(false);
      setError(json.msg);
    }
    if (response.ok) {

      setIsLoading(false);

      return json; // Return the successful response data
    }
  };

  return { signup, error, isLoading };
};
